import { render, staticRenderFns } from "./OrgMajor.vue?vue&type=template&id=2c57ce7b&scoped=true&"
import script from "./OrgMajor.vue?vue&type=script&lang=js&"
export * from "./OrgMajor.vue?vue&type=script&lang=js&"
import style0 from "./OrgMajor.vue?vue&type=style&index=0&id=2c57ce7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57ce7b",
  null
  
)

export default component.exports